module.exports = __webpack_public_path__ + "media/src/application/media/v2-img-3-37652e947839c52ce9b396b2a3dba675.png";